import { Component } from '@angular/core';
import { ModalService } from '../modal.service';

@Component({
    selector: 'app-delete-discount-options-modal',
    templateUrl: './delete-discount-options-modal.component.html',
    styleUrls: ['./delete-discount-options-modal.component.scss'],
})
export class DeleteDiscountOptionsModalComponent {
    modalInput!: {
        data: any;
        callback: (value: 'continue' | 'discontinue') => void;
    };

    constructor(private modal: ModalService) {}

    selectOption(value: 'continue' | 'discontinue') {
        this.modalInput?.callback?.(value);
        this.modal.closeModal();
    }

    cancel() {
        this.modal.closeModal();
    }
}
